import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BackArrow from '../assets/images/Frame_18177.png';

const RegistrationWithAdharOTPVerify = () => {
    const location = useLocation();
    const txnId = location?.state?.txnId || '';

    const [mobileNumber, setMobileNumber] = useState('');
    const [mobileError, setMobileError] = useState('');
    const [inputValue, setInputValue] = useState(['', '', '', '', '', '']);
    const [otpError, setOtpError] = useState('');
    const [seconds, setSeconds] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const inputRefs = useRef([]);

    useEffect(() => {
        if (seconds > 0) {
            const timer = setInterval(() => {
                setSeconds(prevSeconds => prevSeconds - 1);
            }, 1000);
            return () => clearInterval(timer);
        } else {
            setIsResendEnabled(true);
        }
    }, [seconds]);

    const handleResendOTP = () => {
        console.log('Resend OTP');
        setSeconds(60);
        setIsResendEnabled(false);
        setOtpError('');
    };

    const handleChange = (event, index) => {
        const { value } = event.target;
        if (/[^0-9]/.test(value)) return; // Only numeric allowed

        const newValue = [...inputValue];
        newValue[index] = value;
        setInputValue(newValue);

        if (value.length === 1 && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1].focus();
        } else if (value.length === 0 && index > 0) {
            inputRefs.current[index - 1].focus();
        }

        setOtpError('');
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,10}$/.test(value)) { // allow only up to 10 digits
            setMobileNumber(value);
            setMobileError('');
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (mobileNumber.length !== 10) {
            setMobileError('Mobile number must be 10 digits');
            return;
        }

        if (inputValue.join('').length !== 6) {
            setOtpError('Please enter a valid 6-digit OTP');
            return;
        }

        console.log('Form submitted successfully');
        // Proceed with API call or navigation
    };

    return (
        <div>
            {/* Back to Home Button */}
            <div className='flex inline-block'>
                <Link to="/" className="flex w-28 mt-6 ml-4 sm:ml-8 lg:ml-14 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200" style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}>
                    <img src={BackArrow} alt="Back" className="mr-2" style={{ height: '24px', width: '24px' }} />
                    Back
                </Link>
                <span className='mt-8 ml-4' style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}>
                    New Registration
                </span>
            </div>

            {/* Horizontal Line */}
            <hr className="mt-6 mx-4 sm:mx-8 lg:mx-14 border-t-1 border-gray-300" />

            {/* Form */}
            <div className="flex justify-center mt-10 mb-10">
                <div className="bg-[#42424A] shadow-lg rounded-lg p-6 flex flex-col items-center w-full max-w-sm">
                    <form className="w-full" onSubmit={handleSubmit}>
                        {/* Mobile Number Input */}
                        <div className="relative mb-6">
                            <label className="block text-white mb-2" htmlFor="mobile" style={{ fontFamily: 'Roboto', fontSize: '18px', fontWeight: '500' }}>
                                Enter Mobile Number
                            </label>
                            <input
                                type="text"
                                id="mobile"
                                maxLength="10"
                                value={mobileNumber}
                                onChange={handleMobileChange}
                                className={`bg-[#EFFEF7] border ${mobileError ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-lg rounded-lg block w-full h-12 px-4 focus:outline-none focus:ring-2 focus:ring-gray-600 focus:border-transparent`}
                                placeholder="Enter 10-digit mobile number"
                            />
                            {mobileError && <p className="text-red-500 text-md mt-1">{mobileError}</p>}
                        </div>

                        {/* OTP Input */}
                        <div className="relative mb-4 mt-6">
                            <label className="block text-white mb-2" htmlFor="otp" style={{ fontFamily: 'Roboto', fontSize: '18px', fontWeight: '500' }}>
                                Enter OTP
                            </label>
                            <div className="flex justify-between items-center mb-4">
                                <span className='text-white' style={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: '400' }}>
                                    An OTP has been sent to {mobileNumber ? `xxxxxx${mobileNumber.slice(6)}` : 'xxxxxx7272'}
                                </span>
                                {seconds > 0 && (
                                    <span className='text-[#1ACD81]' style={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: '400' }}>
                                        {seconds} sec
                                    </span>
                                )}
                            </div>

                            <div className="flex flex-col">
                                <div className="flex space-x-2">
                                    {inputValue.map((value, index) => (
                                        <div key={index} className="relative">
                                            <input
                                                type="text"
                                                maxLength="1"
                                                ref={(el) => (inputRefs.current[index] = el)}
                                                value={value}
                                                onChange={(event) => handleChange(event, index)}
                                                className={`bg-[#EFFEF7] border ${otpError ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-lg rounded-lg block w-full h-12 text-center focus:outline-none focus:ring-2 focus:ring-gray-600 focus:border-transparent`}
                                                placeholder=""
                                            />
                                        </div>
                                    ))}
                                </div>
                                {otpError && <p className="text-red-500 text-md mt-1">{otpError}</p>}
                            </div>

                            <div className="flex justify-between items-center mb-2 mt-4">
                                <button
                                    type="button"
                                    className={`text-[#1ACD81] w-36 ${isResendEnabled ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                    style={{ fontFamily: 'Roboto', fontSize: '16px', fontWeight: '400' }}
                                    onClick={handleResendOTP}
                                    disabled={!isResendEnabled}
                                >
                                    Resend OTP
                                </button>
                                <button
                                    type="submit"
                                    className='bg-[#1ACD81] text-white w-full py-2 rounded-lg'
                                    style={{ fontFamily: 'Roboto', fontSize: '18px', fontWeight: '500' }}
                                >
                                    VERIFY
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default RegistrationWithAdharOTPVerify;
